import { createAction } from '@reduxjs/toolkit';
import { SDKInitState } from 'utils/eventBus';

export const sdkConfigured = createAction<Partial<SDKInitState>>('sdk/configured');

export const sdkVirtualBackgroundChangedEventRequested = createAction<{
  type: string;
  value: string;
}>('sdk/virtualBackgroundChangedEventRequested');

export const sdkMobileStartScreenshareRequested = createAction(
  'sdk/mobileStartScreenshareRequested'
);
export const sdkMobileStopScreenshareRequested = createAction('sdk/mobileStopScreenshareRequested');
export const sdkMobileScreenshareToggled = createAction('sdk/mobileScreenshareToggled');
export const sdkMobileMediaTokenUpdated = createAction<string>('sdk/mobileMediaTokenUpdated');
